import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Observer } from 'rxjs';
import { Process, ProcessStatus, UploadFileResult, UploadProgress, UploadResult } from '../models/excel-metadata';
import { ConfigService, HttpWrapperService, ICommonMessage, MessageService } from '@gbs-platform-client/fwk-core';
import { map } from 'rxjs/operators';
import { APIResponse } from 'src/app/utils/models/response';

@Injectable({
  providedIn: 'root'
})
export class FileUploaderService {
  constructor(
    private httpClient: HttpClient,
    private httpService: HttpWrapperService,
    private configService: ConfigService,
    private messageService: MessageService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }
  uploadProgress: UploadProgress = new UploadProgress(0, 0);
  apiEndpoint: string = "";
  apiUniqueId: string = 'documentupload/c9854622-f92d-4cc4-ad38-418ca0858ae2/ctrl/TOaocrvKOHOsBcxMtcT3gMnayuEp3/';
  private chunkSize = 1048576;
  private static getErrorResult(reason: any): UploadFileResult {
    return {
      result: {
        succeeded: false,
        fileName: '',
        errorMessage: reason
      },
      tmpDirectoryName: ''
    };
  }

  public upload(file: File, callBack: string): Observable<UploadResult> { 
    return new Observable<UploadResult>(observer => {
      const reader = new FileReader();
      const fileName = file.name;
      reader.onload = (e: any) => {
        this.sendBufferData(reader.result, fileName, observer, callBack);
        e.preventDefault();
      }        
      reader.readAsArrayBuffer(file);
    });
  }
  private async sendBufferData(readResult: string | ArrayBuffer | null,
    fileName: string,
    observer: Observer<UploadResult>,
    callBack: string) {
    if (readResult == null) {
      observer.error('failed reading file data');
      return;
    }
    // create directory for saving chunks by server side application.
    var resultBuffer = new Uint8Array(readResult as ArrayBuffer);
    var message: ICommonMessage = { eventName: callBack, param: new UploadProgress(Math.ceil(resultBuffer.length / this.chunkSize), 0) };
    await this.startSendingData(fileName, message)
      .then(result => this.sendChunks(
        resultBuffer,
        result.tmpDirectoryName,
        message
      ))
      .then(result => this.endSendingData(
        fileName,
        result.tmpDirectoryName,
        message
      ))
      .then(result => {
        if (result.succeeded) {
          observer.next(result);
          observer.complete();
        } else {
          observer.error(result);
        }
      })
      .catch(reason => observer.error(reason));
  }
  private startSendingData(fileName: string, message: ICommonMessage): Promise<UploadFileResult> {
    return new Promise<UploadFileResult>(((resolve, reject) => {
      const formData = new FormData();
      formData.append('fileName', fileName);
      this.httpClient.post<UploadFileResult>(
        this.apiEndpoint + 'files/start',
        formData, {})
        .toPromise()
        .then(result => {
          if (result.result.succeeded) {
            message.param.currentStep = 1;
            this.messageService.sendCommonMessage(message);
            resolve(result);
          } else {
            reject(result);
          }
        })
        .catch(reason => reject(FileUploaderService.getErrorResult(reason)));
    }));
  }
  private async sendChunks(buffer: Uint8Array,
    tmpDirectoryName: string, message: ICommonMessage): Promise<UploadFileResult> {
    message.param.currentStep = 2;
    this.messageService.sendCommonMessage(message);

    return new Promise<UploadFileResult>(async (resolve, reject) => {
      var fileIndex = 0;
      const sendChunkPromises = new Array<Promise<UploadResult>>();
      for (let i = 0; i < buffer.length; i += this.chunkSize) {
        let indexTo = i + this.chunkSize;
        if (indexTo >= buffer.length) {
          indexTo = buffer.length - 1; // for last data.
        }
        const formData = new FormData();
        formData.append('file', new Blob([buffer.subarray(i, indexTo)]));
        const promise = this.httpClient.post<UploadResult>(
          this.apiEndpoint + 'files/chunk',
          formData,
          {
            headers: {
              tmpDirectory: tmpDirectoryName,
              index: fileIndex.toString()
            }
          })
          .toPromise();
        sendChunkPromises.push(promise);
        fileIndex += 1;
      }

      await Promise.all(sendChunkPromises)
        .then(results => {
          if (results.some(r => r.succeeded === false)) {
            reject('failed uploading');
          } else {
            resolve({
              result: {
                succeeded: true,
                errorMessage: '',
                fileName: ''
              },
              tmpDirectoryName
            });
          }
        })
        .catch(reason => reject(FileUploaderService.getErrorResult(reason)));
    });
  }
  private endSendingData(fileName: string, tmpDirectoryName: string, message: ICommonMessage): Promise<UploadResult> {
    return new Promise<UploadResult>(((resolve, reject) => {
      const formData = new FormData();

      const user = JSON.parse(localStorage.getItem('currentUser') || '{}'); 
      let tokenDetails =  user.Token; 

      let token = "Bearer " + tokenDetails
      let httpOptions = {
        headers: new HttpHeaders({
          'Authorization': token
        })
      }  
      formData.append('fileName', fileName);
      formData.append('tmpDirectory', tmpDirectoryName);
      this.httpClient.post<UploadResult>(
        this.apiEndpoint + 'files/end',
        formData, httpOptions)
        .toPromise()
        .then(result => {
          if (result.succeeded) {
            resolve(result);
          } else {
            reject(result);
          }
        })
        .catch(reason => reject(FileUploaderService.getErrorResult(reason).result));
    }));
  }
}